module.exports = __webpack_public_path__ + "img/image_36.9b5f3a44.png";